import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["backdrop", "panel"]

  connect() {
    document.addEventListener("keydown", this.handleKeydown.bind(this))
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown.bind(this))
  }

  open(event) {
    event.preventDefault()
    const modalId = event.currentTarget.dataset.modalId
    const modal = document.getElementById(modalId)

    if (modal) {
      modal.classList.remove("hidden")
      document.body.classList.add("overflow-hidden")

      // Animate in
      requestAnimationFrame(() => {
        const backdrop = modal.querySelector("[data-modal-target='backdrop']")
        const panel = modal.querySelector("[data-modal-target='panel']")

        if (backdrop) {
          backdrop.classList.remove("opacity-0")
          backdrop.classList.add("opacity-100")
        }
        if (panel) {
          panel.classList.remove("opacity-0", "scale-95")
          panel.classList.add("opacity-100", "scale-100")
        }
      })
    }
  }

  close(event) {
    if (event) event.preventDefault()

    const modal = this.element.closest("[data-modal]") || this.element

    const backdrop = modal.querySelector("[data-modal-target='backdrop']")
    const panel = modal.querySelector("[data-modal-target='panel']")

    // Animate out
    if (backdrop) {
      backdrop.classList.remove("opacity-100")
      backdrop.classList.add("opacity-0")
    }
    if (panel) {
      panel.classList.remove("opacity-100", "scale-100")
      panel.classList.add("opacity-0", "scale-95")
    }

    setTimeout(() => {
      modal.classList.add("hidden")
      document.body.classList.remove("overflow-hidden")
    }, 200)
  }

  closeOnBackdrop(event) {
    if (event.target === event.currentTarget) {
      this.close(event)
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      const openModals = document.querySelectorAll("[data-modal]:not(.hidden)")
      if (openModals.length > 0) {
        const lastModal = openModals[openModals.length - 1]
        const backdrop = lastModal.querySelector("[data-modal-target='backdrop']")
        const panel = lastModal.querySelector("[data-modal-target='panel']")

        if (backdrop) {
          backdrop.classList.remove("opacity-100")
          backdrop.classList.add("opacity-0")
        }
        if (panel) {
          panel.classList.remove("opacity-100", "scale-100")
          panel.classList.add("opacity-0", "scale-95")
        }

        setTimeout(() => {
          lastModal.classList.add("hidden")
          document.body.classList.remove("overflow-hidden")
        }, 200)
      }
    }
  }
}
